import { render } from "./Ladder.vue?vue&type=template&id=411d2480&scoped=true"
import script from "./Ladder.vue?vue&type=script&lang=js"
export * from "./Ladder.vue?vue&type=script&lang=js"

import "./Ladder.vue?vue&type=style&index=0&id=411d2480&scoped=true&lang=scss"

import exportComponent from "/var/lib/buildkite-agent/builds/BKxAWS-i-0cc0aef14303b400c-1/assemble-sports/singaporerugby-livescores-production-vertical-traffic-light/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-411d2480"]])

export default __exports__